export const YES_NO: Map<string, boolean> = new Map([
	['yes', true],
	['no', false],
]);
